module.exports = __webpack_public_path__ + "media/images/icon-caret-down-6b16e5c97af506862aa7e613eac3cfe5.svg";